export function withTimeout<T>(millis: number, promise: Promise<T>) {
	const timeout = new Promise<T>((_, reject) =>
		setTimeout(() => reject(`Timed out after ${millis} ms.`), millis)
	);

	return Promise.race([promise, timeout]);
}
